import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    football: {
      today: {
        '1x2': [],
        xht: [],
        xft: [],
        xhtft: [],
        1221: [],
        btts: [],
        over05ht: [],
        over15ht: [],
        over25ft: [],
        over35ft: []
      },
      tomorrow: {
        '1x2': [],
        xht: [],
        xft: [],
        xhtft: [],
        1221: [],
        btts: [],
        over05ht: [],
        over15ht: [],
        over25ft: [],
        over35ft: []
      }
    },
    handball: {
      today: {
        xht: [],
        xft: [],
        xhtft: []
      },
      tomorrow: {
        xht: [],
        xft: [],
        xhtft: []
      }
    }
  },
  getters: {
    football: state => {
      return state.football
    },
    handball: state => {
      return state.handball
    }
  },
  mutations: {
    updateState (state, payload) {
      state[payload.type][payload.day][payload.key] = payload.items
    }
  },
  actions: {
    updateState ({ commit }, payload) {
      commit('updateState', payload)
    }
  }
})
